/**
 * `mpesa` endpoint wrappers — STK push, dynamic QR, STK status query.
 *
 * All three are scoped through the invoice, same as the rest of the payments
 * module (see src/types/mpesa.ts) — reachable by whichever role can already see
 * the target invoice, not restricted to tenants.
 */
import { apiClient } from '../client';
import { MPESA_QR, MPESA_STK_PUSH, MPESA_STK_QUERY } from './paths';
import type {
  QrRequest,
  QrResponse,
  StkPushRequest,
  StkPushResponse,
  StkQueryRequest,
  StkQueryResponse,
} from '../../types/mpesa';

/** `POST mpesa/stk-push/` — starts the push; does NOT itself confirm payment. */
export async function initiateStkPush(payload: StkPushRequest): Promise<StkPushResponse> {
  const response = await apiClient.post<StkPushResponse>(MPESA_STK_PUSH, payload);
  return response.data;
}

/** `POST mpesa/qr/` — `qr_code` is base64 PNG, render as `data:image/png;base64,...`. */
export async function generateQr(payload: QrRequest): Promise<QrResponse> {
  const response = await apiClient.post<QrResponse>(MPESA_QR, payload);
  return response.data;
}

/** `POST mpesa/stk-query/` — poll with the `CheckoutRequestID` from a push. */
export async function queryStkStatus(payload: StkQueryRequest): Promise<StkQueryResponse> {
  const response = await apiClient.post<StkQueryResponse>(MPESA_STK_QUERY, payload);
  return response.data;
}
